import {
  getGroupById,
  createGroup,
  clearGetGroupById,
  updateGroup,
} from "../../../../Redux/Groups/GroupsActions";
import processTermsAndCondition from "../../../../Util/processTermsAndCondition";
import { AppDispatch, RootState } from "../../../../Redux/store";
import toastHelper from "../../../../Util/toastHelper";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import styles from "./GroupInformation.module.scss";
import validator from "../../../../Util/validator";
import React, { useEffect, useState } from "react";
import Editor from "react-simple-wysiwyg";

interface GroupInformationProps {
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  groupId: string;
}

function GroupInformation(props: GroupInformationProps) {
  const { setActiveTab, groupId } = props;
  const dispatch = useDispatch<AppDispatch>();
  const [name, setName] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState("");

  const { createGroupLoading, updateGroupLoading, groupById } = useSelector(
    (state: RootState) => state.groups,
  );

  const [errors, setErrors] = useState<{
    name: string;
    termsAndConditions: string;
  }>({
    name: "",
    termsAndConditions: "",
  });

  const nextHandler = async () => {
    const { errors: fieldsErrors, isValid } = validator([
      {
        key: "name",
        value: name,
        type: "text",
      },

      {
        key: "termsAndConditions",
        value: termsAndConditions,
        type: "text",
      },
    ]);

    setErrors({ ...errors, ...fieldsErrors });
    if (isValid) {
      if (groupId) {
        if (!updateGroupLoading) {
          const successHandler = () => {
            setActiveTab("amenities");
            toastHelper.success("Group updated successfully");
          };

          dispatch(
            updateGroup({
              id: Number(groupId),
              groupName: name,
              terms: processTermsAndCondition(termsAndConditions),
              successHandler,
            }),
          );
        }
      } else {
        if (!createGroupLoading) {
          const successHandler = () => {
            setActiveTab("amenities");
            toastHelper.success("Group created successfully");
          };
          dispatch(
            createGroup({
              groupName: name,
              terms: processTermsAndCondition(termsAndConditions),
              successHandler,
            }),
          );
        }
      }
    }
  };

  useEffect(() => {
    if (groupId) {
      dispatch(getGroupById({ groupId }));
    }
    return () => {
      dispatch(clearGetGroupById());
    };
  }, [groupId, dispatch]);

  useEffect(() => {
    if (groupById) {
      setName(groupById?.groupName || "");
      setTermsAndConditions(processTermsAndCondition(groupById?.terms || ""));
    }
  }, [groupById]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.inputContainer}>
        <p className={styles.label}>Group Name</p>
        <input
          type="text"
          placeholder="Group Name"
          className={styles.input}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <p className={styles.error}>{errors.name}</p>
      </div>
      <div className={styles.inputContainer}>
        <p className={styles.label}>Terms and Conditions</p>
        <Editor
          className={styles.termsInput}
          value={termsAndConditions}
          onChange={(e) => {
            setTermsAndConditions(e.target.value);
          }}
        />
        <p className={styles.error}>{errors.termsAndConditions}</p>
      </div>
      {createGroupLoading || updateGroupLoading ? <Loading /> : <></>}
      <div className={styles.bottomContainer}>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={nextHandler}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default GroupInformation;
